import { InputImagePreview } from "components/InputImage/InputImagePreview";
import { InputImageUpdate } from "components/InputImage/InputImageUpdate";

export function ImageInput({ value, disabled, onChange }: { value?: string | undefined, disabled: boolean, onChange: (data: any) => void }) {

    return (
        <div>
            <label
                htmlFor="price"
                className="block mb-2 text-sm text-gray-900 dark:text-white"
            >
                Upload Your 5 Artworks
            </label>
            {value && value !== "" ? (
                <InputImagePreview
                    value={value}
                    onDelete={() => onChange("")}
                    size="large"
                    disabled={disabled}
                />
            ) : (
                <InputImageUpdate
                    onChange={onChange}
                    size="large"
                    disabled={disabled}
                />
            )}

        </div>
    );
}